import { useQuery, useMutation } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const getExternalJob = (externalJobId) => Axios.get(`/ExternalJobs/${externalJobId}`);

const useExternalJob = (externalJobId) => {
    return useQuery({
        queryKey: ['externalJobs', externalJobId],
        queryFn: () => getExternalJob(externalJobId),
        staleTime: 60000,
        cacheTime: 60000,
        retry: false,
        enabled: externalJobId ? true : false,
    });
};

const forceReloadExternalJob = (ID) => {
    queryClient.invalidateQueries({ queryKey: ['externalJobs', ID] });
};

const onDeleteExternalJob = ({ ID }) => Axios.delete(`/ExternalJobs/${ID}`);

const useDeleteExternalJob = () => {
    return useMutation({
        mutationFn: onDeleteExternalJob,
        onSuccess: (data, variables) => {
            if (variables.ID !== variables.externalJobId) {
                forceReloadExternalJob(variables.externalJobId);
            }
        },
    });
};

const onUpdateExternalJob = ({ externalJobData }) => Axios.put('/ExternalJobs', externalJobData);

const useUpdateExternalJob = () => {
    return useMutation({
        mutationFn: onUpdateExternalJob,
        onSuccess: (data, variables) => {
            forceReloadExternalJob(variables.externalJobData.ID);
        },
    });
};

const onMoveExternalJob = ({ externalJobData }) => Axios.put('/ExternalJobs/MoveEvent', externalJobData);

const useMoveExternalJob = () => {
    return useMutation({
        mutationFn: onMoveExternalJob,
        onSuccess: (data, variables) => {
            forceReloadExternalJob(variables.externalJobData.ID);
        },
    });
};

const onAddExternalJob = ({ externalJobData }) => Axios.post('/ExternalJobs', externalJobData);

const useAddExternalJob = () => {
    return useMutation({
        mutationFn: onAddExternalJob,
        onSuccess: (data, variables) => {
            forceReloadExternalJob(data.ID);
        },
    });
};

const onCancelExternalJob = ({ ID }) => Axios.put(`/ExternalJobs/cancellation/${ID}`);

const useCancelExternalJob = () => {
    return useMutation({
        mutationFn: onCancelExternalJob,
        onSuccess: (data, variables) => {
            forceReloadExternalJob(variables.ID);
        },
    });
};

export {
    useExternalJob,
    useDeleteExternalJob,
    useUpdateExternalJob,
    useAddExternalJob,
    forceReloadExternalJob,
    useCancelExternalJob,
    useMoveExternalJob,
};
